<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
import "@/assets/scss/formstyle.scss"
import "@/assets/scss/element-style.scss"
import "@/assets/scss/wuye-style.scss"
export default {
	name: 'home',
	data() {
		return {

		}
	},
}

</script>

<style lang="scss" >
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif !important;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	// text-align: center;
	background: #F2F5FB;
	color: #2c3e50;
	// min-height: 900px ;
	//min-width: 1700px;
  // min-width: 1440px;
}

::-webkit-scrollbar {
	width: 7px;
	height: 7px;
}

::-webkit-scrollbar-thumb {
	border-radius: 5px;
	background: #C2C8D5;

}

::-webkit-scrollbar-track {
	border-radius: 10px;
	background: #EFF1F5;
}

.hover {
	cursor: pointer !important;
}

.disabled {
	cursor: not-allowed;
}

* {
	margin: 0;
	padding: 0;
	// -webkit-user-select: none;
	// -moz-user-select: none;
	// user-select: none;
	// -ms-user-select: none;
}
.el-tooltip__popper.is-dark{
  max-width: 500px ;
  background-color: #fff !important; /* 背景色 */
  color: #333 !important; /* 文字颜色 */
  border: 1px solid #ccc !important; /* 边框颜色 */
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important; /* 阴影效果 */
}
.el-tooltip__popper.is-dark[x-placement^=top] .popper__arrow::after{
  border-top-color: #ffffff!important;
  border-right-color: transparent !important;
}
.el-tooltip__popper.is-dark[x-placement^=top] .popper__arrow{
  border-top-color: #ccc!important;
  border-right-color: transparent !important;
}

.popper__arrow::after{
  border-bottom-color: #FFFFFF !important;
}
.ljl-opt .el-select-dropdown__item.selected{
  color: #1D78FE !important;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
  color: #1D78FE !important;
}
.el-cascader-panel .el-radio__input.is-checked .el-radio__inner{
  border-color: #1D78FE !important;
  background: #1D78FE !important;
}
.el-cascader-panel .el-radio__input.is-checked .el-radio__inner:hover{
  border-color: #1D78FE !important;
}

.xbqq{
  display: flex;
  align-items: center;
}
.xbqq-text{
  font-size: 14px;
  color: #37578F;
  cursor: pointer;
  font-weight: normal;
}
.xbqq-text:hover{
  color: #1D78FE;
}
.ddtable .cell{
  display: flex;
}
.tableddinput{
  flex-grow: 1;
  justify-content: flex-end;
}
.tableddinput .el-input.is-active .el-input__inner, .el-input__inner:focus{
  border-color:#1D78FE !important;
}
.my-datenewnew .start-date div span{
  color: #FFFFFF !important;
}
.ljl-ddfx .el-input__inner{
  color: #353940 !important;
}
.ljl-ddfx .el-date-editor .el-range-input{
  color: #353940 !important;
}
.ljl-ddbr.select-element-change .el-input__inner{
  border: none !important;
  padding: 0px 15px 0px 0px !important;
}
.ljl-ddbr.select-element-change .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
  color: #1D78FE !important;
}
.dddivbk{
  border: 1px solid #E2E7EE !important;
  height: 32px;
  border-radius: 4px;
  width: 374px;
  margin-bottom: 12px;
  display: flex;
  padding-left: 15px;
  box-sizing: border-box;
  overflow: hidden;
}
.dddivbk2{
  width: 390px !important;
}
.hxx{
  color: #F56C6C;
  padding-top: 6px;
}
.ljl-ddfxbjnr{

}
.ljl-jlgg .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{
  border-color: #1D78FE !important;
}
.ljl-jlgg .el-cascader__tags .el-tag{
  max-width: 120px !important;
}
.ljl-jlgg .el-input__icon{
  line-height: 32px !important;
}
.ljl-jlgg .el-input__icon{
  line-height: 32px !important;
}

.ljl-sel .el-tag{
  max-width: 120px !important;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{
  border-color: #1D78FE !important;
}
.mrl_main_con{
  p{
      margin-block-start: 1em !important;
      margin-block-end: 1em !important;
      margin-inline-start: 0px !important;
      margin-inline-end: 0px !important;
      unicode-bidi: isolate;
  }
}

// @import "@/assets/scss/formstyle.scss"
@import "@/assets/scss/flex.scss";


</style>
